import { render, staticRenderFns } from "./23.vue?vue&type=template&id=1f2e7bba&scoped=true&"
import script from "./23.vue?vue&type=script&lang=js&"
export * from "./23.vue?vue&type=script&lang=js&"
import style0 from "./23.vue?vue&type=style&index=0&id=1f2e7bba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2e7bba",
  null
  
)

export default component.exports